import React, { useEffect } from "react";
import Prism from "prismjs";
import 'prismjs/components/prism-ini';
import '../prism-theme-addon.css'
import { Box, Button, useClipboard, useColorModeValue } from "@chakra-ui/react";

function ConfigView({ code, language }) {
    const { onCopy, hasCopied } = useClipboard(code);
    const bg = useColorModeValue("gray.50", "gray.900");

    useEffect(() => {
        Prism.highlightAll();
    }, [code]);

    return (
        <Box position="relative" bg={bg} p={4} borderRadius="md" overflow="hidden">
            <Button
                size="xs"
                position="absolute"
                top={2}
                right={2}
                onClick={onCopy}
                colorScheme={hasCopied ? "green" : "gray"}
            >
                {hasCopied ? "Copied" : "Copy"}
            </Button>
            <pre style={{ margin: 0, padding: '1rem 0' }}>
                <code className={`language-${language}`}>{code}</code>
            </pre>
        </Box>
    );
}

export default ConfigView;
